import React from "react";

const EoceanPrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-40">
      <h1 className="text-3xl font-bold mb-6">
        Privacy Policy for Eocean
      </h1>

      <p className="mb-4">
        <strong>Effective Date:</strong> 5 May 2026
      </p>

      <p className="mb-6">
        At Eocean, we value your privacy and are committed to protecting your
        personal information. This Privacy Policy explains how we collect, use,
        and safeguard your data when you use our Shopify app.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        1. Information We Collect
      </h2>
      <p className="mb-2">
        We collect the following types of information:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>
          <strong>Personal Information:</strong> When you use our app, we may
          collect personal details such as your name, email address, and phone
          number.
        </li>
        <li>
          <strong>Shopify Store Data:</strong> We access data related to your
          Shopify store, including order details, customer information, and
          shipping statuses, to provide WhatsApp notifications.
        </li>
        <li>
          <strong>Usage Data:</strong> We may collect anonymous data about how
          you interact with our app, such as device information, IP addresses,
          and usage patterns.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">
        2. How We Use Your Information
      </h2>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>
          Send automated WhatsApp notifications related to order confirmation,
          fulfillment, and cancellations.
        </li>
        <li>
          Improve and optimize our app's performance and functionality.
        </li>
        <li>
          Provide customer support and respond to inquiries.
        </li>
        <li>
          Comply with legal obligations.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">
        3. Data Sharing and Disclosure
      </h2>
      <p className="mb-2">
        We do not sell or share your personal information with third parties,
        except as necessary for:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>
          <strong>Service Providers:</strong> We may share data with trusted
          third-party service providers who assist us in operating our app and
          providing services (e.g., WhatsApp API providers).
        </li>
        <li>
          <strong>Legal Compliance:</strong> We may disclose information to
          comply with applicable laws, regulations, or legal processes.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">
        4. Data Security
      </h2>
      <p className="mb-6">
        We take appropriate technical and organizational measures to protect
        your personal information from unauthorized access, alteration, or
        destruction. However, no data transmission over the internet is 100%
        secure, and we cannot guarantee the absolute security of your
        information.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        5. Your Rights
      </h2>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Access, update, or delete your personal information.</li>
        <li>
          Opt-out of receiving WhatsApp notifications at any time.
        </li>
        <li>
          Contact us for any privacy-related concerns or requests.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">
        6. Changes to This Policy
      </h2>
      <p className="mb-6">
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page with an updated effective date. We encourage you to
        review this policy regularly.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        7. Contact Us
      </h2>
      <p className="mb-2">
        If you have any questions or concerns about our Privacy Policy or data
        practices, please contact us at:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>
          <strong>Support Email:</strong>{" "}
          <a
            href="mailto:support@mean3.com"
            className="text-blue-500 hover:underline"
          >
            support@mean3.com
          </a>
        </li>
      </ul>
    </div>
  );
};

export default EoceanPrivacyPolicy;